// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transactions {
    padding: 2rem;
    margin-left: 250px;
    margin-top: 70px;
}

.transactions-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.transactions-header h1 {
    margin: 0;
    color: #1a1a1a;
}

.actions {
    display: flex;
    gap: 1rem;
}

.search-bar {
    display: flex;
    align-items: center;
    width: 300px;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    padding: 0.5rem 1rem;
    background-color: white;
}

.search-icon {
    color: #6b7280;
    margin-right: 0.5rem;
    font-size: 1rem;
}

.search-input {
    flex: 1 1;
    border: none;
    outline: none;
    font-size: 0.875rem;
}

.filter-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    cursor: pointer;
    font-size: 0.875rem;
    color: #1a1a1a;
}

.status-filters {
    display: flex;
    gap: 1rem;
    margin-bottom: 2rem;
}

.status-filters button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 0.5rem;
    background: #f3f4f6;
    color: #6b7280;
    cursor: pointer;
    font-size: 0.875rem;
    transition: all 0.2s;
}

.status-filters button.active {
    background: #2563eb;
    color: white;
}

.transactions-table {
    background: white;
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: visible;
    position: relative;
}

table {
    width: 100%;
    border-collapse: collapse;
}

th {
    background: #f9fafb;
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    color: #4b5563;
    font-size: 0.875rem;
}

td {
    padding: 1rem;
    border-bottom: 1px solid #f3f4f6;
    color: #1a1a1a;
    font-size: 0.875rem;
}

tr:last-child td {
    border-bottom: none;
}

/* Status Styles */
.status {
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize;
    display: inline-block;
    cursor: default;
    transition: opacity 0.2s;
}

.status.pending {
    background-color: #FFF4CC;
    color: #B76E00;
}

.status.processing {
    background-color: #E6EEFF;
    color: #367CFF;
}

.status.in_progress {
    background-color: #CCF6FF;
    color: #0891B2;
}

.status.completed {
    background-color: #E7F4F0;
    color: #198754;
}

.status.failed {
    background-color: #FEECEC;
    color: #A04351;
}

/* Status with note will show pointer cursor */
.status.has-note {
    cursor: help;
}

.status.has-note:hover {
    opacity: 0.8;
}

/* Add hover effect */
.status:hover {
    opacity: 0.9;
}

.pointer {
    cursor: pointer;
}

.action-btn {
    background: none;
    border: none;
    color: #6b7280;
    cursor: pointer;
    padding: 0.25rem;
}

.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-top: 2rem;
}

.pagination button {
    padding: 0.5rem 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    background: white;
    color: #1a1a1a;
    cursor: pointer;
}

.pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.pagination span {
    color: #6b7280;
    font-size: 0.875rem;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
    .transactions {
        padding: 1rem;
    }

    .transactions-header {
        flex-direction: column;
        gap: 1rem;
    }

    .actions {
        flex-direction: column;
        width: 100%;
    }

    .search-bar {
        width: 100%;
    }

    .search-input {
        width: 100%;
    }

    .filter-btn {
        width: 100%;
    }

    .status-filters {
        display: flex;
        overflow-x: auto;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        gap: 0.5rem;
    }

    .status-filters button {
        white-space: nowrap;
    }

    .transactions-table {
        overflow-x: auto;
    }

    table {
        min-width: 800px;
    }

    td {
        white-space: normal;
        min-width: 120px;
    }

    td .d-flex.flex-column {
        font-size: 0.875rem;
    }

    .pagination {
        flex-direction: row;
        justify-content: center;
        gap: 1rem;
        margin-top: 1rem;
    }
}

/* Additional mobile optimizations */
@media screen and (max-width: 480px) {
    .transactions-header h1 {
        font-size: 1.5rem;
    }

    td {
        padding: 0.75rem 0.5rem;
    }

    .status {
        padding: 6px 8px;
        font-size: 12px;
    }
}

.user-name {
    color: #367CFF;
    transition: opacity 0.2s;
}

.user-name:hover {
    opacity: 0.8;
    text-decoration: underline;
}

.cursor {
    cursor: pointer;
}

/* Dropdown styles */
.dropdown-menu {
    min-width: 120px;
    padding: 0.25rem;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.dropdown-item {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    border-radius: 4px;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}

.text-warning {
    color: #ffc107 !important;
}

.text-danger {
    color: #dc3545 !important;
}

/* Modal styles */
.modal-content {
    border-radius: 8px;
}

.modal-header {
    border-bottom: 1px solid #dee2e6;
    padding: 1rem 1.5rem;
}

.modal-body {
    padding: 1.5rem;
}

.modal-footer {
    border-top: 1px solid #dee2e6;
    padding: 1rem 1.5rem;
}

.form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    padding: 0.5rem;
}

.form-control:focus {
    border-color: #367CFF;
    box-shadow: 0 0 0 0.2rem rgba(54, 124, 255, 0.25);
}

/* Action Menu Styles */
.action-cell {
    position: relative;
}

.action-menu {
    position: absolute;
    right: 0;
    bottom: auto;
    top: 80%;
    transform-origin: top right;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    min-width: 120px;
}

.menu-item {
    display: block;
    width: 100%;
    padding: 8px 12px;
    text-align: left;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 14px;
}

.menu-item:hover {
    background-color: #f3f4f6;
}

.menu-item.warning {
    color: #ffc107;
}

.menu-item.danger {
    color: #dc3545;
}

.menu-item.success {
    color: #28a745;
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background: white;
    padding: 24px;
    border-radius: 8px;
    width: 90%;
    max-width: 500px;
}

.modal-content h2 {
    margin-bottom: 16px;
    font-size: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
}

.form-group textarea {
    width: 100%;
    padding: 8px;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    resize: vertical;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
}

.btn {
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.btn.secondary {
    background-color: #6c757d;
    color: white;
}

.btn.warning {
    background-color: #ffc107;
    color: black;
}

.btn.success {
    background-color: #28a745;
    color: white;
}

.btn.danger {
    background-color: #dc3545;
    color: white;
}

.btn.primary {
    background-color: #367CFF;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/Transactions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,wCAAwC;IACxC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,8CAA8C;AAC9C;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,gBAAgB;IACpB;AACJ;;AAEA,oCAAoC;AACpC;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;AACJ;;AAEA;IACI,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iDAAiD;AACrD;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,QAAQ;IACR,2BAA2B;IAC3B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":[".transactions {\n    padding: 2rem;\n    margin-left: 250px;\n    margin-top: 70px;\n}\n\n.transactions-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.transactions-header h1 {\n    margin: 0;\n    color: #1a1a1a;\n}\n\n.actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.search-bar {\n    display: flex;\n    align-items: center;\n    width: 300px;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    padding: 0.5rem 1rem;\n    background-color: white;\n}\n\n.search-icon {\n    color: #6b7280;\n    margin-right: 0.5rem;\n    font-size: 1rem;\n}\n\n.search-input {\n    flex: 1;\n    border: none;\n    outline: none;\n    font-size: 0.875rem;\n}\n\n.filter-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1.5rem;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    color: #1a1a1a;\n}\n\n.status-filters {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.status-filters button {\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: 0.5rem;\n    background: #f3f4f6;\n    color: #6b7280;\n    cursor: pointer;\n    font-size: 0.875rem;\n    transition: all 0.2s;\n}\n\n.status-filters button.active {\n    background: #2563eb;\n    color: white;\n}\n\n.transactions-table {\n    background: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: visible;\n    position: relative;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n}\n\nth {\n    background: #f9fafb;\n    padding: 1rem;\n    text-align: left;\n    font-weight: 600;\n    color: #4b5563;\n    font-size: 0.875rem;\n}\n\ntd {\n    padding: 1rem;\n    border-bottom: 1px solid #f3f4f6;\n    color: #1a1a1a;\n    font-size: 0.875rem;\n}\n\ntr:last-child td {\n    border-bottom: none;\n}\n\n/* Status Styles */\n.status {\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 14px;\n    font-weight: 500;\n    text-transform: capitalize;\n    display: inline-block;\n    cursor: default;\n    transition: opacity 0.2s;\n}\n\n.status.pending {\n    background-color: #FFF4CC;\n    color: #B76E00;\n}\n\n.status.processing {\n    background-color: #E6EEFF;\n    color: #367CFF;\n}\n\n.status.in_progress {\n    background-color: #CCF6FF;\n    color: #0891B2;\n}\n\n.status.completed {\n    background-color: #E7F4F0;\n    color: #198754;\n}\n\n.status.failed {\n    background-color: #FEECEC;\n    color: #A04351;\n}\n\n/* Status with note will show pointer cursor */\n.status.has-note {\n    cursor: help;\n}\n\n.status.has-note:hover {\n    opacity: 0.8;\n}\n\n/* Add hover effect */\n.status:hover {\n    opacity: 0.9;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.action-btn {\n    background: none;\n    border: none;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0.25rem;\n}\n\n.pagination {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.pagination button {\n    padding: 0.5rem 1rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    background: white;\n    color: #1a1a1a;\n    cursor: pointer;\n}\n\n.pagination button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.pagination span {\n    color: #6b7280;\n    font-size: 0.875rem;\n}\n\n/* Responsive Styles */\n@media screen and (max-width: 768px) {\n    .transactions {\n        padding: 1rem;\n    }\n\n    .transactions-header {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .actions {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .search-bar {\n        width: 100%;\n    }\n\n    .search-input {\n        width: 100%;\n    }\n\n    .filter-btn {\n        width: 100%;\n    }\n\n    .status-filters {\n        display: flex;\n        overflow-x: auto;\n        padding-bottom: 0.5rem;\n        margin-bottom: 1rem;\n        gap: 0.5rem;\n    }\n\n    .status-filters button {\n        white-space: nowrap;\n    }\n\n    .transactions-table {\n        overflow-x: auto;\n    }\n\n    table {\n        min-width: 800px;\n    }\n\n    td {\n        white-space: normal;\n        min-width: 120px;\n    }\n\n    td .d-flex.flex-column {\n        font-size: 0.875rem;\n    }\n\n    .pagination {\n        flex-direction: row;\n        justify-content: center;\n        gap: 1rem;\n        margin-top: 1rem;\n    }\n}\n\n/* Additional mobile optimizations */\n@media screen and (max-width: 480px) {\n    .transactions-header h1 {\n        font-size: 1.5rem;\n    }\n\n    td {\n        padding: 0.75rem 0.5rem;\n    }\n\n    .status {\n        padding: 6px 8px;\n        font-size: 12px;\n    }\n}\n\n.user-name {\n    color: #367CFF;\n    transition: opacity 0.2s;\n}\n\n.user-name:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n/* Dropdown styles */\n.dropdown-menu {\n    min-width: 120px;\n    padding: 0.25rem;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.dropdown-item {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n    border-radius: 4px;\n}\n\n.dropdown-item:hover {\n    background-color: #f8f9fa;\n}\n\n.text-warning {\n    color: #ffc107 !important;\n}\n\n.text-danger {\n    color: #dc3545 !important;\n}\n\n/* Modal styles */\n.modal-content {\n    border-radius: 8px;\n}\n\n.modal-header {\n    border-bottom: 1px solid #dee2e6;\n    padding: 1rem 1.5rem;\n}\n\n.modal-body {\n    padding: 1.5rem;\n}\n\n.modal-footer {\n    border-top: 1px solid #dee2e6;\n    padding: 1rem 1.5rem;\n}\n\n.form-control {\n    border-radius: 4px;\n    border: 1px solid #ced4da;\n    padding: 0.5rem;\n}\n\n.form-control:focus {\n    border-color: #367CFF;\n    box-shadow: 0 0 0 0.2rem rgba(54, 124, 255, 0.25);\n}\n\n/* Action Menu Styles */\n.action-cell {\n    position: relative;\n}\n\n.action-menu {\n    position: absolute;\n    right: 0;\n    bottom: auto;\n    top: 80%;\n    transform-origin: top right;\n    background: white;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    z-index: 1000;\n    min-width: 120px;\n}\n\n.menu-item {\n    display: block;\n    width: 100%;\n    padding: 8px 12px;\n    text-align: left;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.menu-item:hover {\n    background-color: #f3f4f6;\n}\n\n.menu-item.warning {\n    color: #ffc107;\n}\n\n.menu-item.danger {\n    color: #dc3545;\n}\n\n.menu-item.success {\n    color: #28a745;\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background: white;\n    padding: 24px;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 500px;\n}\n\n.modal-content h2 {\n    margin-bottom: 16px;\n    font-size: 20px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n}\n\n.form-group textarea {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #e5e7eb;\n    border-radius: 4px;\n    resize: vertical;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 24px;\n}\n\n.btn {\n    padding: 8px 16px;\n    border-radius: 4px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.btn.secondary {\n    background-color: #6c757d;\n    color: white;\n}\n\n.btn.warning {\n    background-color: #ffc107;\n    color: black;\n}\n\n.btn.success {\n    background-color: #28a745;\n    color: white;\n}\n\n.btn.danger {\n    background-color: #dc3545;\n    color: white;\n}\n\n.btn.primary {\n    background-color: #367CFF;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
